import { useEffect, useState } from "react";
import dynamicfunction from "../../utils/dynamicfunction";
import { useDispatch, useSelector } from "react-redux";
import { getContentKeyAccToLang } from "../../utils/utils";
import {
  changeTradingSettings,
  getTradingSettings,
  getTradingSettingsDropdown,
  resetTradingSettings,
} from "../../store/actions/settingAction";

export default () => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();

  const { settingContent } = useSelector((state) => state.content);
  const { tradingSettingsDropdown, settingLoading, resetLoading } = useSelector(
    (state) => state.setting
  );

  const [tradingSettings, setTradingSettings] = useState({
    orderSide: null,
    goodTill: null,
    buyMode: null,
    fillTerm: null,
    sellMode: null,
    portfolio: null,
    cashAccount: null,
    isPricingServer: null,
    isPlacement: null,
    isBitOffer: null,
  });

  const setData = (data) => {
    const tradingData = formatTradingData(data, tradingSettingsDropdown);
    setTradingSettings({ ...tradingData });
  };

  const getData = async () => {
    await dispatch(getTradingSettings((data) => setData(data)));
    await dispatch(getTradingSettingsDropdown());
  }

  useEffect(() => {
    getData();
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      settingContent?.web_trading_setting?.data?.attributes,
      key,
      isArabic
    );
  };

  const handleTradingSettings = (key, val) =>
    setTradingSettings((prev) => ({ ...prev, [key]: val }));

  const saveSettings = () => {
    const api_data = {
      orderSideId: tradingSettings?.orderSide?.id,
      orderTypeInBuyModeId: tradingSettings?.buyMode?.id,
      orderTypeInSellModeId: tradingSettings?.sellMode?.id,
      goodTillId: tradingSettings?.goodTill?.id,
      fillTermId: tradingSettings?.fillTerm?.id,
      portfolioCode: tradingSettings?.portfolio?.code,
      cashAccountCode: tradingSettings?.cashAccount?.code,
      isConnectToPricingServer: tradingSettings?.isPricingServer,
      isClearAfterPlacement: tradingSettings?.isPlacement,
      isBidOfferPrice: tradingSettings?.isBitOffer,
    };
    dispatch(changeTradingSettings(api_data, () => getData()));
  };

  const resetSettings = () => {
    const api_data = {
      orderSideId: null,
      orderTypeInBuyModeId: null,
      orderTypeInSellModeId: null,
      goodTillId: null,
      fillTermId: null,
      portfolioCode: null,
      cashAccountCode: null,
      isConnectToPricingServer: false,
      isClearAfterPlacement: false,
      isBidOfferPrice: false,
    };

    dispatch(resetTradingSettings(api_data, () => getData()));
  };

  return {
    isArabic,
    TextWeight,
    settingLoading,
    resetLoading,
    tradingSettings,
    getContentKey,
    handleTradingSettings,
    tradingSettingsDropdown,
    saveSettings,
    resetSettings,
  };
};

const formatTradingData = (tradingSettings, tradingDropdown) => {
  const getFilter = (arr, key = "id", value) =>
    arr?.filter((item) => item?.[key] === value);

  return {
    orderSide: getFilter(
      tradingDropdown?.orderSides,
      tradingSettings?.orderSideId
    ),
    goodTill: getFilter(
      tradingDropdown?.goodTills,
      tradingSettings?.goodTillId
    ),
    buyMode: getFilter(
      tradingDropdown?.orderTypeInBuyModes,
      tradingSettings?.orderTypeInBuyModeId
    ),
    sellMode: getFilter(
      tradingDropdown?.orderTypeInSellModes,
      tradingSettings?.orderTypeInSellModeId
    ),
    portfolio: getFilter(
      tradingDropdown?.clientPortfolios,
      "code",
      tradingSettings?.portfolioCode
    ),
    fillTerm: getFilter(
      tradingDropdown?.fillTerms,
      tradingSettings?.fillTermId
    ),
    cashAccount: getFilter(
      tradingDropdown?.cashAccounts,
      "code",
      tradingSettings?.cashAccountCode
    ),
    isPricingServer: tradingSettings?.isConnectToPricingServer,
    isPlacement: tradingSettings?.isClearAfterPlacement,
    isBitOffer: tradingSettings?.isBidOfferPrice,
  };
};
